import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { ICancelAppointmentParams } from "@api/appointment/types";
import { generatePath } from "@routes/generatePath.ts";
import { useAppointmentTable } from "@api/appointment/getAppointmentTable";
import { useShowAppointment } from "@api/appointment/showAppointment";
import { useAppointmentDetail } from "@api/appointment/getAppointmentDetail";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, queryClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
type IVariables = ICancelAppointmentParams;

export const cancelAppointment: IAxiosFn<IVariables, IResponse> = (data) => {
  return axiosClient.delete(
    generatePath("/appointments/:appointment_id", {
      appointment_id: data?.appointmentId.toString(),
    }),
  );
};

export const useCancelAppointment = createMutation<IResponse, IVariables>({
  mutationFn: (data) => cancelAppointment(data),
  onSuccess: (_, { appointmentId }) => {
    queryClient.invalidateQueries(useAppointmentTable.getKey());
    queryClient.invalidateQueries(useShowAppointment.getKey({ appointmentId }));
    queryClient.invalidateQueries(
      useAppointmentDetail.getKey({ id: appointmentId?.toString() }),
    );
  },
});
